import {useCurrentState} from "../globalState";
import {useAPI} from "../stateHelpers";
import ListItemText from "@material-ui/core/ListItemText";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import React, {useRef, useState} from "react";
import {withRouter} from "react-router-dom";
import {IconButton, ListItemSecondaryAction, Typography} from "@material-ui/core";
import {ValidatorForm} from "react-form-validator-core";
import TextValidator from "./TextValidator";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import Button from "@material-ui/core/Button";
import Delete from "@material-ui/icons/Delete";
import BugReport from "@material-ui/icons/BugReport";
import {apiDelete, apiPost} from "../api";
import snackbar from "../snackbar";
import spawnConfirmation from "../confirmationDialog";
import {GenerateInputs} from "./GenericInputField";
import FailedLoading from "./FailedLoading";
import CircularLoader from "./CircularLoader";
import {useTranslation} from "react-i18next";

function RequestsPage(props) {

    let [title, setTitle] = useCurrentState("title");

    /*
        The defaultValue is only accepted once - from that point on the state is handled by inner callbacks of react
     */

    let senders = useAPI("identity");
    const {data = [], error, isLoading, setData, doRetry} = useAPI("sign_request");
    const inputRef = useRef(null);
    const {t, i18n} = useTranslation();


    let getSenders = () => {
        return (senders.data || []).map((item) => {
            return {label: item.name + ' (' + item.email + ')', key: item.email};
        });
    };

    let inputs = GenerateInputs({
        url: {
            label: 'URL',
            type: 'url',
            help: 'enter a valid url the document is located',
            validators: ['required'],
            errorMessages: ['this field is required', 'url is not valid']
        },
        callback_url: {
            label: 'Callback url',
            help: 'url where the events will be posted to',
            type: 'url'
        },
        sender: {
            required: true,
            label: 'Sender',
            type: 'select',
            selection: getSenders(),
            help: 'select which sender to use for sending',
            validators: ['required'],
            errorMessages: ['this field is required']
        },
        title: {
            label: 'Title',
            help: 'document title'
        },
        emails: {
            label: 'E-mails',
            type: 'text',
            help: 'comma separated value list of e-mails that will sign this',
            validators: ['required']
        }
    });

    if (!senders.isLoading && !inputs.sender.value && senders.data) {
        inputs.sender.setValue(senders.data[0].email);
    }

    setTitle("Requests");

    const {
        history,
        ...rest
    } = props;

    if (error) {
        return <FailedLoading retry={doRetry}/>
    }

    if (isLoading) {
        return <CircularLoader/>
    }

    let loading = inputs.emails.disabled;

    let deleteRequest = async (item) => {
        spawnConfirmation().then(() => apiDelete("sign_request/" + item.unique_id).then(() => {
            setData(data.filter((itm) => itm.id !== item.id));
            snackbar("Deleted.");
        }, (e) => {
            console.error(e);
            snackbar("Failed deleting. Please try again!");
        }));
    };

    let submit = () => {
        let signers = inputs.emails.value.split(",").map((item) => {
            return {email: item.trim()};
        });
        inputs.disableAll(true);
        apiPost("sign_request", {
            document_url: inputs.url.value,
            document_name: inputs.title.value,
            callback_url: inputs.callback_url.value,
            sender: {
                email: inputs.sender.value
            },
            signers: signers
        }).then(res => {
            snackbar("Added!");
            doRetry();
        }, res => {
            snackbar("Error: " + res.response.data.message);
        }).finally(() => inputs.disableAll(false));
    };

    return (
        <div>
            <div style={{padding: 16}}>
                <div>
                    <Card>
                        <CardContent>
                            <Typography variant="h5" component="h2">Quick sign request add</Typography>
                            <div>
                                <ValidatorForm ref={inputRef} onSubmit={submit} noValidate autoComplete="off">
                                    <div>
                                        {inputs.title.field}
                                    </div>
                                    <div>
                                        {inputs.url.field}
                                    </div>
                                    <div>
                                        {inputs.emails.field}
                                    </div>
                                    <div>
                                        {inputs.sender.field}
                                    </div>
                                    <div>
                                        {inputs.callback_url.field}
                                    </div>
                                </ValidatorForm>
                            </div>
                        </CardContent>
                        <CardActions>
                            <Button onClick={() => submit()} disabled={loading} color="primary">
                                Add
                            </Button>
                        </CardActions>
                    </Card>
                </div>
            </div>
            <List>
                {(data || []).map((item) => <ListItem button
                                                      onClick={() => history.push("/sign-request/" + item.unique_id)}
                                                      key={item.id} alignItems="flex-start">
                    <ListItemText
                        primary={item.document_name + ' (' + item.status + ')'}
                        secondary={t("created_on_sign_request", {
                            created_at: item.created_at
                        }) + (item.document_url ? t("created_via", {url: item.document_url}) : '')}
                    />
                    <ListItemSecondaryAction>
                        <IconButton title="Debug" onClick={(e) => {
                            e.stopPropagation();
                            history.push("/debug/sign-request/" + item.unique_id);
                        }}>
                            <BugReport/>
                        </IconButton>
                        <IconButton onClick={() => deleteRequest(item)}>
                            <Delete/>
                        </IconButton>
                    </ListItemSecondaryAction>
                </ListItem>)}
            </List>
        </div>
    )
}

export default withRouter(RequestsPage);